import { profile } from '../data/profile';
import { whatsappContacts, buildWhatsAppUrl, buildTelUrl } from '../data/contact';
import { ui } from '../data/ui';
import { SEO } from '../components/ui/SEO';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import './ContactPage.css';

export function ContactPage() {
  return (
    <>
      <SEO title={ui.seo.contact} description={ui.contact.subtitle} />

      <div className="page-header">
        <div className="container">
          <SectionHeader
            label={ui.nav.contact}
            title={ui.contact.title}
            subtitle={ui.contact.subtitle}
            align="center"
          />
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <ScrollReveal>
              <div className="contact-whatsapp glass-card">
                <h3 className="contact-whatsapp-title">{ui.contact.whatsappTitle}</h3>
                <p className="contact-whatsapp-sub">{ui.contact.whatsappSub}</p>
                <p className="contact-whatsapp-hint">{ui.contact.whatsappHint}</p>

                <div className="whatsapp-buttons">
                  {whatsappContacts.map((channel) => (
                    <a
                      key={channel.id}
                      href={buildWhatsAppUrl(channel.number)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsapp-btn"
                    >
                      <span className="whatsapp-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                        </svg>
                      </span>
                      <span className="whatsapp-btn-text">
                        <span className="whatsapp-btn-label">
                          {channel.id === 'jordan' ? ui.contact.whatsappJordan : ui.contact.whatsappSaudi}
                        </span>
                        <span className="whatsapp-btn-number">{channel.display}</span>
                      </span>
                    </a>
                  ))}
                </div>
              </div>

              {/* نموذج الإدخال — معطّل مؤقتاً
              <form className="contact-form glass-card" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">{ui.contact.name}</label>
                    <input type="text" id="name" name="name" className="form-input" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">{ui.contact.email}</label>
                    <input type="email" id="email" name="email" className="form-input" required />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="company">{ui.contact.company}</label>
                  <input type="text" id="company" name="company" className="form-input" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="projectType">{ui.contact.projectType}</label>
                    <select id="projectType" name="projectType" className="form-select" required>
                      <option value="">{ui.contact.selectType}</option>
                      {ui.contact.projectTypes.map((type) => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="budget">{ui.contact.budget}</label>
                    <select id="budget" name="budget" className="form-select">
                      <option value="">{ui.contact.selectBudget}</option>
                      {ui.contact.budgetRanges.map((range) => (
                        <option key={range} value={range}>{range}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="message">{ui.contact.message}</label>
                  <textarea id="message" name="message" className="form-textarea" required />
                </div>
                <Button type="submit" variant="primary">{ui.contact.send}</Button>
              </form>
              */}
            </ScrollReveal>

            <ScrollReveal delay={0.1}>
              <div className="contact-info">
                <div className="contact-info-block glass-card">
                  <h3>{ui.contact.contactInfo}</h3>
                  <div className="contact-detail">
                    <span className="detail-label">{ui.contact.email}</span>
                    <a href={`mailto:${profile.email}`}>{profile.email}</a>
                  </div>
                  {whatsappContacts.map((channel) => (
                    <div key={channel.id} className="contact-detail">
                      <span className="detail-label">
                        {channel.id === 'jordan' ? ui.contact.whatsappJordan : ui.contact.whatsappSaudi}
                      </span>
                      <a href={buildTelUrl(channel.number)}>{channel.display}</a>
                    </div>
                  ))}
                  <div className="contact-detail">
                    <span className="detail-label">{ui.resume.location}</span>
                    <span>{profile.location}</span>
                  </div>
                </div>

                <div className="contact-info-block glass-card">
                  <h3>{ui.contact.connect}</h3>
                  {profile.socialLinks.map((link) => (
                    <div key={link.name} className="contact-detail">
                      <span className="detail-label">{link.name}</span>
                      {link.url.startsWith('[') ? (
                        <span>{link.url}</span>
                      ) : (
                        <a
                          href={link.url}
                          target={link.url.startsWith('http') ? '_blank' : undefined}
                          rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                        >
                          {link.name}
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>
    </>
  );
}
